import { render, staticRenderFns } from "./MonthlyTaxAffin.vue?vue&type=template&id=88de4cc8&scoped=true"
import script from "./MonthlyTaxAffin.vue?vue&type=script&lang=js"
export * from "./MonthlyTaxAffin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88de4cc8",
  null
  
)

export default component.exports